module.exports = __webpack_public_path__ + "static/media/IIT_foundation2.9154bde6.png";